import o from "./index128.js";
/* empty css         */
import t from "./index130.js";
const m = /* @__PURE__ */ t(o, [["__scopeId", "data-v-d963767e"]]);
export {
  m as default
};
